module.exports = __webpack_public_path__ + "img/Best of Waadt Rot.20f81d23.jpg";